// extracted by mini-css-extract-plugin
export default {"row":"MainContent_row__eC2R0"};